import Particle from './Particle'
import Navbar from './Navbar/Navbar'
import { Link } from 'react-router-dom'






function Tours() {
  return (
    <div>
    <Navbar/>
   {/* <Particle id="particles"/>*/}
    <h1 className="title2">Selecciona una Empresa para Comprar Tu Tour</h1>
    <div className="sponsorcontainer">
    <a 
    href="https://rockroadstours.com/" 
    className="btn" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <img
      src="../images/rockroads.png"
      className="sponsor"
      alt="Maad Shirts"
    />
  </a>

  <a 
  href="https://concerttours.mx/" 
  className="btn" 
  target="_blank" 
  rel="noopener noreferrer"
>
  <img
    src="../images/concerttours.jpg"
    className="sponsor"
    alt="E Ticket"
  />
</a>

<a 
href="https://ontourviajes.com/" 
className="btn" 
target="_blank" 
rel="noopener noreferrer"
>
<img
  src="../images/ontour.png"
  className="sponsor"
  alt="Boleto Movil"
/>
</a>


<a 
href="https://www.facebook.com/profile.php?id=100063032601175" 
className="btn" 
target="_blank" 
rel="noopener noreferrer"
>
<img
  src="../images/rocknrolltours.jpg"
  className="sponsor"
  alt="Estadio Akron"
/>
</a>

<a
href="https://www.facebook.com/RockTouurs"
className="btn"
target="_blank" 
rel="noopener noreferrer"
>
<img
  src="../images/rock-tours.jpg"
  className="sponsor"
  alt="Viagogo"
/>
</a>

</div>
<Link 
className="btn" 
to="/merch" 
style={{
  display: 'block',
  textAlign: 'center',
  width: '100%',  // Ensure it spans full width
  padding: '10px 0', // Adjust padding for better layout
}}
>
<button>
  Para  comprar mercancia oficial de tu Grupo Favorito! <br/>
   Presiona Aqui !!!
</button>
</Link>
    
    
    </div>
  
  )
}

export default Tours